<template>
  <div class="applications">
    <OurTabs v-model="selectedTab" class="tabs" size="lg">
      <OurTab
        v-for="item in noticesOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :disabled="item.disabled"
      />
    </OurTabs>
    <OurGroups>
      <OurGroup v-if="!isSelectedAdd" :title="$t('newApplications.companyDetails')">
        <OurInput
          v-model="form.companyName"
          :label="$t('label.companyTitle')"
          :placeholder="$t('placeholder.title')"
          :error="companyNameError"
          :disabled="form.sentToOneC"
        />

        <OurSelect
          v-model="form.companyType"
          :options="types"
          :label="$t('label.companyType')"
          :placeholder="$t('placeholder.companyType')"
          :disabled="true"
        />

        <OurInput
          v-if="form.companyType === 'juridicalPerson'"
          v-model="form.companyCode"
          :label="$t('label.taxNumber')"
          :placeholder="$t('placeholder.taxNumber')"
          :disabled="true"
        />

        <OurInput
          v-if="form.companyType === 'naturalPerson'"
          v-model="form.taxNumber"
          :label="$t('label.taxNumber')"
          :placeholder="$t('placeholder.taxNumber')"
          :disabled="true"
        />

        <OurInput
          v-if="form.companyType === 'juridicalPerson'"
          v-model="form.taxNumber"
          :label="$t('label.personalTaxNumber')"
          :placeholder="$t('placeholder.personalTaxNumber')"
          :disabled="true"
        />

        <OurSelect
          v-model="form.regionId"
          :options="regions"
          :label="$t('label.region')"
          :placeholder="$t('placeholder.selectRegion')"
          :error="regionError"
          item-label="name"
          :disabled="form.sentToOneC"
        />

        <OurSelect
          v-model="form.managerId"
          :options="managers"
          :label="$t('label.manager')"
          :placeholder="$t('placeholder.manager')"
          :error="managerError"
          :disabled="form.sentToOneC"
        />

        <OurSelect
          v-model="form.processingManagerId"
          :options="managers"
          :label="$t('label.processManager')"
          :placeholder="$t('placeholder.manager')"
          :error="processManagerError"
          :disabled="form.sentToOneC"
        />

        <OurButton
          v-if="!form.sentToOneC"
          class="button"
          :text="$t('button.sendtoOneC')"
          @click.prevent="sendToOneC"
        />
        <p v-else class="text-sm text-gray-500">Дані компанії були успішно відправлені до 1С</p>
      </OurGroup>
      <OurGroup
        v-if="!isSelectedAdd"
        :title="$t('newApplications.dealerDetails')"
        :loading="!!!companies.length"
      >
        <OurInput
          v-model="form.name"
          :label="$t('label.title')"
          :placeholder="$t('placeholder.title')"
          :error="titleError"
        />

        <OurMultiselect
          v-if="companies.length"
          v-model="form.companies"
          :options="companies"
          :label="$t('label.company') + ' *'"
          :placeholder="$t('placeholder.selectCompany')"
          item-label="label"
          :error="companiesError"
          :reload="true"
          :loading="loading"
          @reloadData="reload"
        />

        <p v-if="companies.length" class="text-sm text-gray-500">
          * Перша вибрана компанія буде компанією за замовчуванням
        </p>

        <OurSelect
          v-model="form.accessGroupId"
          :options="accessGroups"
          :label="$t('label.accessGroup')"
          :placeholder="$t('placeholder.chooseFromList')"
          :error="accessGroupError"
        />

        <OurSelect
          v-model="form.storageId"
          :options="storages"
          :label="$t('label.storage')"
          :placeholder="$t('placeholder.selectStorage')"
          item-label="name"
          :error="storageError"
        />

        <OurSelect
          v-model="form.levelId"
          :options="bonusLevels"
          :label="$t('label.bonusLevel')"
          :placeholder="$t('placeholder.bonusLevel')"
          item-label="name"
          :error="levelError"
          :disabled="!getPermission['bonus_program.set_level']"
        />
      </OurGroup>
      <OurGroup :title="$t('newApplications.userDetails')">
        <PaginationSelect
          v-if="isSelectedAdd"
          v-model="form.customerId"
          :options="customers"
          :options-limit="customers?.length"
          :label="$t('label.customer')"
          :placeholder="$t('placeholder.selectCustomer')"
          :error="customerError"
        />

        <OurInput
          v-model="form.lastName"
          :label="$t('label.lastName')"
          :placeholder="$t('placeholder.lastName')"
          :disabled="true"
        />

        <OurInput
          v-model="form.firstName"
          :label="$t('label.name')"
          :placeholder="$t('placeholder.name')"
          :disabled="true"
        />

        <OurSelect
          v-model="form.roleId"
          :options="roles"
          :label="$t('label.role')"
          :placeholder="$t('placeholder.selectRole')"
          :error="roleError"
          disabled
        />

        <OurInput
          v-model="form.email"
          data-cy="email-input"
          :label="$t('label.email')"
          :placeholder="$t('placeholder.email')"
          :disabled="true"
        />

        <OurPhoneInput
          v-model="form.phone"
          :label="$t('label.phoneNumber')"
          :placeholder="$t('placeholder.phone')"
          :flags="false"
          dropdown-disabled
          :disabled="true"
        />

        <OurTextarea
          v-model="form.comment"
          :label="$t('label.comment')"
          :placeholder="$t('placeholder.comment')"
          rows="4"
        />
      </OurGroup>
    </OurGroups>
  </div>
</template>

<script>
import ValidationService from "@/services/validation.service";
import { email, maxLength, minLength, numeric, requiredIf } from "vuelidate/lib/validators";
import { mapGetters, mapMutations, mapState } from "vuex";
import apolloMixin from "@/mixins/apollo.mixin";
import PaginationSelect from "@/ui/select/PaginationSelect.vue";
import { allCustomersQuery } from "@/views/settings/customers/index/gql/queries";

const { TAX_NUMBER_COMPANY_MAX_LENGTH, TAX_NUMBER_MIN_LENGTH, TEXT_MAX_LENGTH } = ValidationService;

export default {
  name: "ApplicationsForm",
  components: { PaginationSelect },

  mixins: [apolloMixin],

  props: {
    value: {
      type: Object,
      default: () => {},
    },

    editForm: {
      type: Boolean,
      default: false,
    },

    userDeleted: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    regions: {
      type: Array,
      default: () => [],
    },

    bonusLevels: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      form: {
        companyName: "",
        companyType: "",
        companyCode: "",
        name: "",
        taxNumber: "",
        lastName: "",
        firstName: "",
        sentToOneC: false,
        regionId: "",
        managerId: "",
        processingManagerId: "",
        roleId: "",
        email: "",
        phone: "",
        comment: "",
        storageId: "",
        accessGroupId: "",
        levelId: "1",
        companies: [],
        customerId: "",
      },
      types: [
        {
          id: "naturalPerson",
          label: "Фізична особа",
        },
        {
          id: "juridicalPerson",
          label: "Юридична особа",
        },
      ],
      selectedTab: "addNew",
      noticesOptions: [
        { value: "addNew", label: this.$t("label.createNew") },
        { value: "add", label: this.$t("label.addOneMore") },
      ],
    };
  },

  validations: {
    form: {
      companyName: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
      },
      regionId: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
      },
      managerId: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
      },
      processingManagerId: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
      },
      name: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
      },
      taxNumber: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
        numeric,
        minLength: minLength(TAX_NUMBER_MIN_LENGTH),
        maxLength: maxLength(TAX_NUMBER_COMPANY_MAX_LENGTH),
      },
      firstName: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
        maxLength: maxLength(TEXT_MAX_LENGTH),
      },
      lastName: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
        maxLength: maxLength(TEXT_MAX_LENGTH),
      },
      email: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
        email,
      },
      roleId: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
      },
      storageId: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
      },
      accessGroupId: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
      },
      companies: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
      },
      levelId: {
        required: requiredIf(function () {
          if (!this.isSelectedAdd) {
            return true;
          }
        }),
      },
      customerId: {
        required: requiredIf(function () {
          if (this.isSelectedAdd) {
            return true;
          }
        }),
      },
    },
  },

  computed: {
    ...mapState("dealerUsers", ["roles", "companies", "customers"]),
    ...mapState("dealerCompany", ["managers", "accessGroups"]),
    ...mapState("accessGroups", ["storages"]),
    ...mapGetters("user", ["isUserDealerAdmin", "isUserDealer", "getPermission"]),

    isSelectedAdd() {
      return this.selectedTab === "add";
    },

    titleError() {
      const isDirty = this.$v.form.name.$dirty;
      const isFilled = this.$v.form.name.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },

    companyNameError() {
      const isDirty = this.$v.form.companyName.$dirty;
      const isFilled = this.$v.form.companyName.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },

    regionError() {
      const isDirty = this.$v.form.regionId.$dirty;
      const isFilled = this.$v.form.regionId.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },

    managerError() {
      const isDirty = this.$v.form.managerId.$dirty;
      const isFilled = this.$v.form.managerId.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },

    processManagerError() {
      const isDirty = this.$v.form.processingManagerId.$dirty;
      const isFilled = this.$v.form.processingManagerId.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },

    roleError() {
      const isDirty = this.$v.form.roleId.$dirty;
      const isFilled = this.$v.form.roleId.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },

    storageError() {
      const isDirty = this.$v.form.storageId.$dirty;
      const isFilled = this.$v.form.storageId.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },

    accessGroupError() {
      const isDirty = this.$v.form.accessGroupId.$dirty;
      const isFilled = this.$v.form.accessGroupId.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },

    levelError() {
      const isDirty = this.$v.form.levelId.$dirty;
      const isFilled = this.$v.form.levelId.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },

    companiesError() {
      const isDirty = this.$v.form.companies.$dirty;
      const isFilled = this.$v.form.companies.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },

    customerError() {
      const isDirty = this.$v.form.customerId.$dirty;
      const isFilled = this.$v.form.customerId.required;

      let error = "";

      if (isDirty && !isFilled) {
        error = this.$t("validation.required");
      }

      return error;
    },
  },

  watch: {
    value: {
      handler: "getForm",
      deep: true,
    },
    selectedTab: {
      handler: function () {
        this.$v.$reset();
      },
    },
  },

  mounted() {
    this.getForm();
    this.getAllCustomers();
  },

  methods: {
    ...mapMutations("dealerUsers", ["SET_CUSTOMERS"]),

    async getAllCustomers() {
      const { allCustomer } = await this.$get(allCustomersQuery);

      this.SET_CUSTOMERS(allCustomer);
    },

    getForm() {
      if (this.value) {
        this.form = { ...this.value };
      }
    },

    sendToOneC() {
      if (
        this.$v.form.companyName.$invalid ||
        this.$v.form.regionId.$invalid ||
        this.$v.form.managerId.$invalid ||
        this.$v.form.processingManagerId.$invalid
      ) {
        this.$v.form.companyName.$touch();
        this.$v.form.regionId.$touch();
        this.$v.form.managerId.$touch();
        this.$v.form.processingManagerId.$touch();

        return;
      }

      this.$emit("send", {
        companyName: this.form.companyName,
        regionId: this.form.regionId,
        managerId: this.form.managerId,
        processingManagerId: this.form.processingManagerId,
      });
    },

    reload() {
      this.$emit("reload");
    },

    emitForm() {
      if (this.$v.$invalid) {
        this.$v.$touch();

        this.$nextTick(() => {
          const error = document.querySelector(".error");

          if (error) {
            error.scrollIntoView({ behavior: "instant", block: "end" });
          } else {
            const errorInput = document.querySelector(".error-input");

            if (errorInput) {
              errorInput.scrollIntoView({ behavior: "instant", block: "end" });
            }
          }
        });

        return;
      }

      this.form.isValid = true;
      this.$emit("input", this.form);
    },

    emitSaveForm() {
      this.$emit("input", this.form);
    },
  },
};
</script>

<style scoped>
.applications:deep {
  .our-divider-wrapper {
    display: none;
  }
}
</style>
